<template>
  <common-dialog
    :value="getPdfDialog.visible"
    width="800px"
    @close="handleClose"
    
  >
  <template #header>
    <span class="title">{{ getPdfDialog.title }}</span>
  </template>
    <template #body>
      <div class="pdf-dialog-body">
        <ul class="list">
          <li class="item" v-for="item in getPdfDialog.list">
            <a :href="item.fileUrl || item.reportFile" target="_blank">{{
              item.title || item.invoiceHeader
            }}</a>
          </li>
        </ul>
      </div>
    </template>
  </common-dialog>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import CommonDialog from "@/components/CommonDialog";

export default {
  name: "pdf-dialog",

  components: {
    CommonDialog
  },

  computed: {
    ...mapGetters("order", ["getPdfDialog"])
  },

  methods: {
    ...mapMutations("order", ["setPdfDialog"]),
    handleClose() {
      this.setPdfDialog({
        visible: false
      });
    }
  }
};
</script>
<style lang="less" scoped>
.item {
  padding: 10px 15px;
  line-height: 25px;

  &:nth-child(odd) {
    background-color: #f3f4f4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PdfListDialog/index.vue